var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"border":"none"},attrs:{"className":"doc","src":_vm.docValue,"onload":"onLoad()","onerror":"onError()","sandbox":"allow-same-origin allow-scripts allow-forms"}})}
var staticRenderFns = []

export { render, staticRenderFns }